/**
 * The API stores timestamps as naive UTC (`DateTime(timezone=False)` with
 * `utcnow`) and serialises them without an offset ("2026-10-06T08:14:00").
 * `new Date()` would read those as local time — three hours off in Riyadh —
 * so a missing offset is treated as UTC.
 */
const HAS_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/i;

export function parseServerTimestamp(value: string | null | undefined): Date | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  const iso = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T');
  const date = new Date(HAS_OFFSET.test(iso) || !iso.includes('T') ? iso : `${iso}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** `yyyy-MM-dd` of a date in the browser's local calendar (for `run_date`). */
export function localDateKey(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Local `Date` at midnight for a `yyyy-MM-dd` key; null when malformed. */
export function dateFromKey(key: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key);
  if (!match) return null;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Shift a `yyyy-MM-dd` key by whole days. */
export function shiftDateKey(key: string, days: number): string {
  const date = dateFromKey(key) ?? new Date();
  date.setDate(date.getDate() + days);
  return localDateKey(date);
}
